import { useContext, useEffect, useState } from 'react';
import { LocalizationContext } from '@context/LocalizationContext';
import { AdditionalAnswerOptions } from 'src/types/QuestionTypes';
import { Stack, TextField, Typography } from '@mui/material';
import { InvestigationContext } from 'src/Context/InvestigationContext';
import { useAnalytics } from 'src/hooks/useAnalytics';
import { REFINE_ANALYTICS_EVENTS } from 'src/types/RefineAnalyticsEvents';
import { useQuestionMetrics } from '@hooks/useQuestionMetrics';

interface IFinalQuestionProps {
	setCurrentAnswer: (answerId: any, answerText?: any, additionalOptions?: AdditionalAnswerOptions) => void;
	questionId: string;
}

export default function FinalQuestionComponent(props: IFinalQuestionProps) {
	const { FileUpload } = useContext(LocalizationContext);
	const { investigationDetails } = useContext(InvestigationContext);
	const { trackRefineEvent } = useAnalytics();

	const [answer, setAnswer] = useState<string>('');
	// Preselect the file upload checkbox if there are attachments and user clicked back or if the server sent a preCheckFileUploadCheckbox flag

	useQuestionMetrics({ questionId: props.questionId });
	// RND-4305 — the DCF (check-deposit) flow must NOT show the "Add supporting document(s)"
	// step. The FE gates the upload-file transition on fileUploadChecked, so suppress it for
	// the check-deposit investigation type (backend now resolves DCF -> 'checkDeposit').
	const fileUploadChecked = investigationDetails?.investigationType !== 'checkDeposit';
	const parseAnswerOptions = () => {
		const answerOptions: AdditionalAnswerOptions = {
			fileUploadChecked,
		};
		return answerOptions;
	};

	// Reset the answer and loading state when the question changes
	useEffect(() => {
		setAnswer('');
		props.setCurrentAnswer(props.questionId ?? '', answer, { fileUploadChecked });
	}, [props.questionId]);

	// Fire analytics event when page loads
	useEffect(() => {
		trackRefineEvent(REFINE_ANALYTICS_EVENTS.OPTIONAL_QUESTION_SCREEN_LOADED);
	}, []);
	const handleAnswerChange = (e: any) => {
		setAnswer(e.target.value);
		props.setCurrentAnswer(props.questionId ?? '', e.target.value, parseAnswerOptions());
	};
	return (
		<Stack width={'100%'} alignItems={'center'} height={'100%'} gap={'24px'} data-cy="pqFinalQuestionnaireScreen">
			<Typography
				textAlign={'center'}
				tabIndex={0}
				aria-label={`The question is ${investigationDetails?.nextQuestion.questionText}`}
				variant={'questionText'}>
				{investigationDetails?.nextQuestion.questionText}
			</Typography>

			<TextField
				data-cy={'	pqOpenQuestionAnswerTextField'}
				id="open-answer"
				required
				multiline
				sx={{
					width: {
						xxs: '100%',
						xs: '100%',
						sm: '100%',
						md: '60%',
						lg: '60%',
					},
				}}
				rows={4}
				label={FileUpload?.AnswerButton ?? 'Answer'}
				value={answer}
				variant="outlined"
				onChange={handleAnswerChange}
			/>
		</Stack>
	);
}
